import BillLading from '@/components/BillLading/BillLading';
import jwt_decode from 'jwt-decode';
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
export default {
    name: "collectSealConfirm",
	conditionData:'',
	created: function () {
      this.init();
	},
	components:{
		BillLading,
		pdf
	},
    data() {
        return {
			edit: true,
			showBillLading : false,
			showPdf :true,
			pdfSrc: '',
			numPages: 0,
			progress: 0,
			progressShow: true,
            billLadingData: {
              }
        }
    },
    methods: {
        init(){
			// 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
			this.conditionData = this.$routerUtil.getParam();
			if(this.conditionData.row){
				this.billLadingData.shipper = this.conditionData.row.shipper;
				this.billLadingData.consignee = this.conditionData.row.consignee;
				this.billLadingData.notifyParty = this.conditionData.row.notifyParty;
				this.billLadingData.placeOfreceipt = this.conditionData.row.placeOfreceipt;
				this.billLadingData.vessel = this.conditionData.row.vessel;
				this.billLadingData.portOfLoading = this.conditionData.row.portOfLoading;
				this.billLadingData.portOfTransshipment = this.conditionData.row.portOfTransshipment;
				this.billLadingData.PortOfDischarge = this.conditionData.row.PortOfDischarge;
				this.billLadingData.PlaceOfDelivery = this.conditionData.row.PlaceOfDelivery;
				this.billLadingData.freightCharges = this.conditionData.row.freightCharges;
				this.billLadingData.NoOfOriginal = this.conditionData.row.NoOfOriginal;
				this.billLadingData.declared = this.conditionData.row.declared;
				this.billLadingData.voyageNo = this.conditionData.row.voyageNo;
				this.billLadingData.preCarriageBy = this.conditionData.row.preCarriageBy;
				this.billLadingData.planceAndDate = this.conditionData.row.planceAndDate;
				this.billLadingData.forwardingAgent = this.conditionData.row.forwardingAgent;
				this.billLadingData.signedBy = this.conditionData.row.signedBy;
				this.billLadingData.typeOfMovement = this.conditionData.row.typeOfMovement;
				this.billLadingData.blNo = this.conditionData.row.blNo;
				this.billLadingData.finalDestination = this.conditionData.row.finalDestination;
				this.billLadingData.totalNumber = this.conditionData.row.totalNumber;
				this.billLadingData.goodList = this.conditionData.row.billGoods;
				this.billLadingData.isAddtionalImageDisplay = this.conditionData.row.isAddtionalImageDisplay;
				if (this.conditionData.row.billSignatureFile) {
					this.conditionData.row.billSignatureFile.forEach(file => {
						if (file.type === 1) {
							this.pdfSrc = pdf.createLoadingTask({url: '/api' + file.file, CMapReaderFactory});
						}
					});
				}
				this.pdfSrc.onProgress = progress => {
					let tempProgress = progress.loaded / progress.total * 100;
					if(tempProgress > 100){
						tempProgress = 100;
					}
					this.progress = tempProgress;
					if (this.progress === 100) {
						setTimeout(() => {
							this.progressShow = false;
							for(const key in require.cache) {
								if(require && require.cache && require.cache[key] && require.cache[key].exports && require.cache[key].exports.default instanceof Uint8Array){
									console.log(key);
									delete require.cache[key];
								}
							}
						}, 500);
					}
				};
				this.loadPdfHandler();
			}
		},
		doConfirm(rcSignatureConfirmResult){
			var param = new Object();
			param.id = this.conditionData.row.id
			param.version = this.conditionData.row.version;
			const token = jwt_decode(sessionStorage.getItem('token'));
			if (rcSignatureConfirmResult === 1) {
				param.rcSignatureConfirmResult = "1";
			} else {
				param.rcSignatureConfirmResult = "0";
			}
			param.rcSignatureConfirmUserAccount = token.userAccount;
			param.rcSignatureConfirmUserName = token.userName;
			param.rcSignatureConfirmDay = this.getNowFormatDate();
			console.log(param);
			this.$axios({
				method: "put",
					url: "/api/receipts/recordVerifyUpdate", // 接口地址
					data:param
					}).then(res => {
						console.log();
						if(res.data.status==='1'){
							this.$message({
								// message: this.$t(res.data.message),
								// 2021-01-29 修改提示消息
								message: this.$t('c_sealConfirm.successMessage'),
								type: 'success',
								center: true
							});
							// this.$routerUtil.setParam(this.conditionData.searchForm);
							// this.$router.push('seal-confirm-manage');
							this.back();
						} else {
							this.$message({
								message: this.$t(res.data.message),
								type: 'error',
								center: true
							});
						}
						}).catch(error => {
							console.log(error);
							this.$message({
								message: 'This is an error message',
								type: 'error',
								center: true
							});
					}); 
		},
		// doCancel(){
		// 	var param = new Object();
		// 	param.id = this.conditionData.row.id
		// 	param.version = this.conditionData.row.version;
		// 	const token = jwt_decode(sessionStorage.getItem('token'));
		// 	param.rcSignatureConfirmResult = "0";
		// 	param.rcSignatureConfirmUserAccount = token.userAccount;
		// 	param.rcSignatureConfirmUserName = token.userName;
		// 	param.rcSignatureConfirmDay = this.getNowFormatDate();
		// 	console.log(param);
		// 	this.$axios({
		// 		method: "put",
		// 			url: "/api/receipts/recordVerifyUpdate", // 接口地址
		// 			data:param
		// 			}).then(res => {
		// 				console.log();
		// 				if(res.data.status==1){
		// 					this.$message.success(this.$t('c_addWriteBill.successMassage'));
		// 					this.$routerUtil.setParam(this.conditionData.searchForm);
		// 					this.$router.push('seal-confirm-manage');
		// 				}
		// 				}).catch(error => {
		// 					console.log(error);
		// 					this.$message.error('This is an error message');
		// 			}); 
		// },
		getNowFormatDate() {
			const date = new Date();
			const seperator1 = "-";
			const seperator2 = ":";
			let month = date.getMonth() + 1;
			let strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			return date.getFullYear() + seperator1 + month + seperator1 + strDate
			+ " " + date.getHours() + seperator2 + date.getMinutes()
			+ seperator2 + date.getSeconds();
		},
		loadPdfHandler() {
			this.pdfSrc.promise.then(pdf => {
				this.numPages = pdf.numPages;
			});
		},
		back() {
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('seal-confirm-manage');
		}
    }
}
